import React from 'react'

const DeviceCardFake = () => {
  return (
    <>
      <div className='device-card-fake'>
        <div className='skeleton device-card-fake--image' />
        <div className='skeleton device-card-fake--text' />
        <div className='skeleton device-card-fake--text' />
      </div>
      <style jsx>{`
        .device-card-fake {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          width: 12rem;
          margin-bottom: 1rem;
          &--image {
            width: 100%;
            height: 11rem; 
          }
          &--text {
            height: 18px;
            width: 100%;
          }
        }
        `}</style>
    </>
  )
}

export default DeviceCardFake;